module.exports = __webpack_public_path__ + "static/2.c9345bf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/2.jpg
// module id = 485
// module chunks = 76778261247453